import { fetchData, postData } from "./apis";

const path = "/order";

export const purchaseOrderDeleteApi = (value) => {
  let endPoint = `${path}/purchase-order-delete`;
  return postData(endPoint, value);
};

export const purchaseOrderVouchersApi = (value) => {
  let endPoint = `${path}/purchse-order-vouchers`;
  return postData(endPoint, value);
};

export const salesOrderVouchersApi = (value) => {
  let endPoint = `${path}/sales-order-vouchers`;
  return postData(endPoint, value);
};
